import React from "react";
import { MapPin, Navigation } from "lucide-react";
import { PrismOutline } from "@/components/Prism";
import { AxorButton } from "@/components/primitives";
import { AXOR_ADDRESS_LINES, AXOR_ADDRESS } from "@/config";

export const LocationBlock = () => (
  <div
    className="relative overflow-hidden rounded-[28px] border border-white/[0.08] bg-white/[0.02] backdrop-blur-xl"
    data-testid="location-block"
  >
    <div className="grid md:grid-cols-2">
      <div className="relative p-8 md:p-10">
        <span className="inline-flex items-center gap-2 rounded-full border border-axor-cyan/25 bg-axor-cyan/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-axor-cyan">
          <MapPin className="h-3.5 w-3.5" />
          Our Office
        </span>
        <h3 className="mt-6 text-2xl font-semibold tracking-tight text-axor-white">
          Axor Technologies
        </h3>
        <address className="mt-3 not-italic text-lg leading-relaxed text-axor-white/75">
          {AXOR_ADDRESS_LINES.map((line) => (
            <span key={line} className="block">
              {line}
            </span>
          ))}
        </address>
        <AxorButton
          href={`https://maps.google.com/?q=${encodeURIComponent(AXOR_ADDRESS)}`}
          target="_blank"
          rel="noopener noreferrer"
          variant="secondary"
          icon={Navigation}
          className="mt-8"
          data-testid="location-directions"
        >
          Get Directions
        </AxorButton>
      </div>

      {/* Stylized map / location visual (CSS + SVG, no external image dependency) */}
      <div className="relative min-h-[240px] overflow-hidden bg-gradient-to-br from-axor-navy/40 to-axor-deep">
        <div className="absolute inset-0 opacity-40 [background-image:linear-gradient(rgba(22,184,212,0.12)_1px,transparent_1px),linear-gradient(90deg,rgba(22,184,212,0.12)_1px,transparent_1px)] [background-size:32px_32px]" />
        <PrismOutline className="absolute right-8 top-8 opacity-40" size={90} />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <span className="relative flex h-16 w-16 items-center justify-center">
            <span className="absolute inset-0 animate-ping rounded-full bg-axor-cyan/30" />
            <span className="absolute inset-2 rounded-full bg-axor-cyan/20" />
            <span className="relative flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-axor-cyan to-axor-turquoise text-axor-hero">
              <MapPin className="h-5 w-5" />
            </span>
          </span>
        </div>
        <span className="absolute bottom-6 left-6 text-xs font-medium uppercase tracking-[0.16em] text-axor-white/50">
          St Petersburg, Florida
        </span>
      </div>
    </div>
  </div>
);
